import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { apiFetch } from '../lib/api';
import { useAppStore } from '../store/useAppStore';

interface HealthResponse {
  status: string;
  timestamp: string;
}

export function HomePage() {
  const sidebarOpen = useAppStore((s) => s.sidebarOpen);
  const toggleSidebar = useAppStore((s) => s.toggleSidebar);

  const { data, isLoading, isError } = useQuery({
    queryKey: ['health'],
    queryFn: () => apiFetch<HealthResponse>('/health'),
  });

  return (
    <div className="mx-auto max-w-2xl p-8">
      <h1 className="text-3xl font-bold text-gray-900">App</h1>
      <p className="mt-2 text-gray-600">
        Scheletul proiectului este gata. Frontend-ul (React + Vite + Tailwind + React Query +
        Zustand) este conectat la backend-ul Express.
      </p>

      <div className="mt-6 rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h2 className="font-semibold text-gray-800">Stare backend</h2>
        {isLoading && <p className="text-gray-500">Se verifică…</p>}
        {isError && (
          <p className="text-red-600">Backend-ul nu este accesibil (pornește API-ul pe :24001).</p>
        )}
        {data && (
          <p className="text-green-700">
            {data.status} — {new Date(data.timestamp).toLocaleString('ro-RO')}
          </p>
        )}
      </div>

      <div className="mt-6 flex items-center gap-4">
        <button
          onClick={toggleSidebar}
          className="rounded bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
        >
          Comută bara laterală (Zustand): {sidebarOpen ? 'deschisă' : 'închisă'}
        </button>
        <Link to="/about" className="text-sm text-blue-600 underline">
          Despre
        </Link>
      </div>
    </div>
  );
}
